import Intro from 'blocks/intro';

export default Intro;
